module.exports = __webpack_public_path__ + "media/46.77ab3e4d.wav";